import { TextRun } from "docx";

export const useTokenTextRun = (token: ParagraphToken) => {
  const sanitizedText = useSanitizeTextForWordExport(token.text);

  const textRun = new TextRun({
    text: token.text == "\u000b" ? "\n" : sanitizedText,
    ...useConvertTokenToRunFormatting(token.formatting),
  });

  return textRun;
};
